import { DestroyRef, Injectable } from '@angular/core';
import { RetailProduct } from 'src/app/models/retail-product';
import { RetailItemStoreService } from '../retail-item.store.service';
import { ConfigService } from '../../services/config.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take, withLatestFrom } from 'rxjs';
import { RetailItemPersistence } from './retail-item-persistence.interface';

@Injectable()
export class RetailItemPersistenceService implements RetailItemPersistence {
  constructor(
    private store: RetailItemStoreService,
    private configService: ConfigService,
    private destroyRef: DestroyRef
  ) {}
  add(item: RetailProduct) {
    this.configService.taxRates
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        withLatestFrom(this.configService.currentLocation),
        take(1)
      )
      .subscribe(([taxRates, currentLocation]) => {
        this.store.addItem({
          retail_product_id: item.id,
          quantity: 1,
          unit_price: item.retail_price ?? 0,
          location_id: currentLocation?.id ?? 1,
          tax_rate:
            taxRates.find((taxRate) => taxRate.type === item.sales_tax_type)
              ?.value ?? 0,
          tax_rate_type: item.sales_tax_type
        });
      });
  }
  attemptQuickAdd(args: {
    quantity: number;
    barcode?: string;
    search?: string;
    retail_product_id?: number;
  }) {
    this.store.quickAdd(args);
  }
}
